import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import * as _ from "lodash"
import {
  TICKET_MODULE_NAMESPACE,
  TICKET_GET_TICKETS,
  TICKET_RESET_TICKETS,
  TICKET_SET_TICKETS_PARAMETER
} from '../../../store/ticket';
import { ITicketParameter, ITicketListingViewModel, TicketParameter } from '../../../models/ticket';
import { IPagination, IGenericDefaultSelectOption, GenericDefaultSelectOption } from '../../../models/generic';
import { ActivityStatus, StateTypes } from '../../../common/enums';
import { APARTMENT_MODULE_NAMESPACE, APARTMENT_GET_APPARTMENTS, APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE, APARTMENT_RESET_APARTMENTS, APARTMENT_RESET_APPARTMENTS } from '../../../store/apartment';
import { IApartmentListingViewModel, IApartmentParameter } from '../../../models/apartment';
import { BLOCK_MODULE_NAMESPACE, BLOCK_SET_LOADER_STATE, BLOCK_LOADERS } from '../../../store/block';

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const ApartmentStore= namespace(APARTMENT_MODULE_NAMESPACE)
const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    'list-item': async () => import('@/containers/ticket/components/ticket-list-item/TicketListItem.vue'),
    'sub-navigation-title-duplicate': async () => import('@/components/sub-navigation-title-duplicate/SubNavigationTitleDuplicate.vue'),
    'ticket-list-loader': async () => import('../../ticket/loaders/ticket-list-loader/TicketListLoader.vue'),
    'ticket-list-filters-loaders' : async () => import('../../ticket/loaders/ticket-list-filters-loader/TicketListFiltersLoader.vue')
  }
})
class BlockTickets extends Vue {

  @Prop({ default: true, type: [Boolean] })
  hasFilter: boolean
  /**
   *
   */
  dtTabs: string[];
  dtTab: number;
  dtSearchParameter: ITicketParameter;
  dtMenu: boolean;
  dtCurrentApartment: string
  _cleatTimeout: any;

  constructor() {
    super();
    this.dtSearchParameter = new TicketParameter({
      state: [],
      apartment: []
    });

    this.dtTabs = [
      'basicSearch'
    ]
    this.dtTab = null;
    this.dtMenu= false
    this.dtCurrentApartment= ''
  }

  @TicketStore.Action(TICKET_GET_TICKETS)
  storeGetTickets: (payload: { param: ITicketParameter, merge: boolean }) => Promise<ITicketListingViewModel[]>;
  @TicketStore.Mutation(TICKET_SET_TICKETS_PARAMETER)
  storeResetParam: (payload: ITicketParameter) => void;
  @TicketStore.Mutation(TICKET_RESET_TICKETS)
  storeResetTickets: () => void;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS)
  storeGetApartmentByBlockId: (payload: { param: IApartmentParameter, blockId: string, merge: boolean }) => Promise<IApartmentListingViewModel[]>;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (param: { blockId: number | number[], key: string }) => Promise<any>
  @ApartmentStore.Mutation(APARTMENT_RESET_APPARTMENTS)
  storeResetApartments: () => void
  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void


  @TicketStore.Getter activityStatus: ActivityStatus;
  // @TicketStore.Getter tickets: ITicketListingViewModel[];
  @TicketStore.Getter pagination: IPagination;
  @TicketStore.Getter ticketViewModels: ITicketListingViewModel[];
  @ApartmentStore.Getter apartments: IApartmentListingViewModel[];
  @BlockStore.Getter loaders: Map<string,boolean>

  get isLoading(): boolean {
    return this.activityStatus === ActivityStatus.Loading
  }
  // get ticketViewModels(): ITicketListingViewModel[] {
  //   return this.tickets || [];
  // }

  get coSearchParameter() {
    this.dtSearchParameter.block = [Number(this.$route.params.id)]
    return {
      param: { ...this.dtSearchParameter },
      merge: false
    }
  }

  get fkTicketState(): string[] | number[] {
    return this.dtSearchParameter.state
  }
  set fkTicketState(value: string[] | number[]) {
    this.dtSearchParameter.state = value;
  }
  get fKTicketApartment(): number | number[] {
    console.log("this.dtSearchParameter.apartment=",this.dtSearchParameter.apartment)
    return this.dtSearchParameter.apartment
  }
  set fKTicketApartment(value: number | number[]) {
    this.dtSearchParameter.apartment= value
  }

  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get coStates(): IGenericDefaultSelectOption<string>[] {
    return [
      StateTypes.Open,
      StateTypes.InProgress,
      StateTypes.ReOpen,
      StateTypes.Close
    ].map(type => new GenericDefaultSelectOption<string>(this.$t(this.lblSetting.lblState[type]).toString(), type));
  }
  /*get coApartments(){
    if(!this.apartments) return []
    return this.apartments.map(apt => apt.apartment).map(apt => ({ ...apt, name: apt.apartment_number }))
  }*/
  get coApartments () {
     console.log('co apartments',this.apartments)
     return (this.apartments || []).map(x => {
      if(!x.apartment) return
      x= x.apartment
      return {
        value: x.id,
        text: x['location_number'] ? x['location_number'] + ' / ' + x['apartment_number'] : x['apartment_number']
      }
    })
  }
  get coCurrentAptName(){
    return this.dtCurrentApartment
  }
  set coCurrentAptName(value: string){
    console.log('current apartment new  value',value)
    this.dtCurrentApartment= value
  }
  get coFilterLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.FILTER)
  }
  created() {
    if(this.hasFilter) {
      this.storeSetLoaderState({ key: BLOCK_LOADERS.FILTER, value: true })
      this.storeGetApartmentByBlockId(
        {
          blockId: this.$route.params.id,
          param: { block: parseInt(this.$route.params.id), $limit: 100 },
          merge: false }
        )
        .then(apartments => {
          /*const { apartment }= apartments[0]
          this.coCurrentAptName= apartment.apartment_number
          this.dtSearchParameter= {
            ...this.dtSearchParameter,
            apartment: [apartment.id]
          }
          console.log('get apartments results',apartments,this.apartments)*/
        })
        .finally(() => this.storeSetLoaderState({ key: BLOCK_LOADERS.FILTER, value: false }))
    }
  }
  mounted() {
    //this.storeGetTickets(this.coSearchParameter);
    /** Assign default value for state */
    this.dtSearchParameter = {
      ...this.dtSearchParameter,
      state: [StateTypes.Open, StateTypes.InProgress, StateTypes.ReOpen]
    }
  }
  beforeDestroy() {
    this.dtSearchParameter = new TicketParameter({ key: null, block:  null, apartment: [] });
    console.log("search parameter=",this.dtSearchParameter)
    this.storeResetParam(this.dtSearchParameter);
    this.storeResetApartments()
  }

  handleApartmentClick(event: { data: any, index: number }) {
    console.log('event data',event.data,event.index)
    console.log('co search parameter',this.dtSearchParameter)
    this.dtMenu= false
    if(event.data && event.data.id){
      //this.dtSearchParameter.apartment= [event.data.id]
      this.coCurrentAptName= event.data.text  || event.data.name
      this.dtSearchParameter= {
        ...this.dtSearchParameter,
        apartment: [event.data.id]
      }
      console.log('new search parameter',this.dtSearchParameter)
      //this.storeGetTickets()
      //this.$forceUpdate()
    }
    /*clearTimeout(this._cleatTimeout)
    this._cleatTimeout = setTimeout(() => {
      this.dtMenu = false;
      this.$router.push({
        path: `/block/${event.data.id}`,
        params: {
          id: event.data.id
        }
      })
    }, 300);*/
  }

  handleApartmentRemoteFetch (key: string, cb: Function, loading: Function) {
    const param: any = { key: key }

    param.blockId= this.dtSearchParameter.block

    this.storeGetApartmentsAutocomplete(param)
      .then(res => {
        cb((res || []).map(x => ({
          value: x.id, text: x.apartment_number
        })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  setTicketLoaderState(value: boolean){
    this.storeSetLoaderState({ key: BLOCK_LOADERS.TICKETS, value })
  }

  setFilterLoaderState(value: boolean){
    this.storeSetLoaderState({ key: BLOCK_LOADERS.FILTER, value })
  }
}

export default BlockTickets;



// WEBPACK FOOTER //
// ./src/containers/block/block-tickets/index.ts